module.exports = __webpack_public_path__ + "static/media/help-button-1.951c80a3.png";